import { Button, Modal } from "react-bootstrap";
import type { StagedChangesBreakdown } from "./regDataAlignmentDisplay";

export interface RegDataApplyConfirmModalProps {
    show: boolean;
    applying: boolean;
    breakdown: StagedChangesBreakdown;
    onCancel: () => void;
    onConfirm: () => void;
}

export function RegDataApplyConfirmModal({
    show,
    applying,
    breakdown,
    onCancel,
    onConfirm,
}: RegDataApplyConfirmModalProps) {
    const { total, syncCount, softDeleteCount } = breakdown;

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Update regulatory data?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">
                    You are about to update <strong>{total}</strong> regulatory{" "}
                    {total === 1 ? "record" : "records"}. This writes to your reference data and cannot be undone from
                    this screen.
                </p>
                <ul className="small mb-0">
                    {syncCount > 0 && (
                        <li>
                            <strong>{syncCount}</strong> sync{syncCount === 1 ? "" : "s"} (add, update, reactivate, or
                            restore)
                        </li>
                    )}
                    {softDeleteCount > 0 && (
                        <li>
                            <strong>{softDeleteCount}</strong> soft-delete{softDeleteCount === 1 ? "" : "s"}
                        </li>
                    )}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel} disabled={applying}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={applying}>
                    {applying ? "Applying…" : `Update ${total} records`}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
